import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: () => import(/* webpackChunkName: "home" */ "../views/Home.vue"),
  },
  {
    path: "/funding",
    name: "Support the Game",
    component: () =>
      import(/* webpackChunkName: "funding" */ "../views/Funding.vue"),
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: (to, from, savedPosition) =>
    from.fullPath === to.fullPath
      ? undefined // Fix issue where the image viewer scrolls to top after closed
      : to.hash
      ? {
          el: to.hash,
          top: 210,
          behavior: "smooth",
        }
      : {
          left: 0,
          top: 0,
          behavior: "smooth",
        },
});

export default router;
